var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBackofshirtWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 19 19"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M2.14 2.217 5.79 1s1.667.833 3.333.833S12.457 1 12.457 1l3.65 1.217a1.666 1.666 0 0 1 1.116 1.858l-.483 2.892a.834.834 0 0 1-.825.7h-1.792V16a1.667 1.667 0 0 1-1.666 1.667H5.79c-.917 0-1.667-.75-1.667-1.667V7.667H2.332a.83.83 0 0 1-.825-.7l-.484-2.892A1.67 1.67 0 0 1 2.14 2.217"
})));
export default SvgBackofshirtWhite;